module.exports = __webpack_public_path__ + "fonts/GothamBold.db33e70b.ttf";